import { Column, CreateDateColumn, DeleteDateColumn, PrimaryGeneratedColumn } from 'typeorm';

export class PerguntaBase {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  descricao: string = '';

  @Column()
  temMaximoRespostas: boolean = false;

  @Column()
  maximoRespostas: number = 0;

  @Column()
  obrigatorio: boolean = false;

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;
}

export default PerguntaBase;
